import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';

export const PayoutBalanceOverviewSchema = z
    .object({
        currency: EnumSchema(Currency).describe('The currency of the balance overview'),
        available: z.number().optional().describe('Available balance'),
        inTransit: z.number().optional().describe('Balance in transit'),
        paid: z.number().optional().describe('Paid amount'),
        readyPayouts: z.number().optional().describe('Total ready payouts amount'),
        readyPayoutsCount: z.number().optional().describe('Count of ready payouts'),
    })
    .strict();

export class PayoutBalanceOverview extends FromSchema(PayoutBalanceOverviewSchema) {
    currency: Currency;
    available?: number;
    inTransit?: number;
    paid?: number;
    readyPayouts?: number;
    readyPayoutsCount?: number;
}
